export function normalizeRouterPathname(pathname) {
  if (typeof pathname !== 'string' || pathname.length === 0) {
    return '/';
  }

  if (pathname.startsWith('/')) {
    return pathname.replace(/^\/+/, '/');
  }

  return `/${pathname}`;
}

export function normalizeRouterPath(path) {
  if (typeof path !== 'string' || path.length === 0) {
    return '/';
  }

  const suffixIndex = path.search(/[?#]/);
  const pathname = suffixIndex >= 0 ? path.slice(0, suffixIndex) : path;
  const suffix = suffixIndex >= 0 ? path.slice(suffixIndex) : '';

  return `${normalizeRouterPathname(pathname)}${suffix}`;
}

export function getRouterLocationPath(location) {
  return normalizeRouterPath(`${location?.pathname ?? ''}${location?.search ?? ''}${location?.hash ?? ''}`);
}
